"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.persona = void 0;
exports.persona = {
    id: 1,
    first_name: 'Test',
    last_name: 'Person',
    gender: 'male',
    email: 'test@example.com',
    persona_type_id: 1,
    full_name: 'Test Person',
    profile_image: [{ image_type: 'crop', url: 'test.jpg' }],
    date_of_birth: '2000-01-01',
    phone: '5555555555'
};
